'use client';

import type { ReactNode } from 'react';

/**
 * Error component for färdiga-spel PIX.
 *
 * @returns The error component
 */
export default function ConsumePixError(): ReactNode {
  return (
    <div className="mt-6 mb-8 flex flex-col items-center">
      <h2>Något gick fel vid inladdning av PIX</h2>
    </div>
  );
}
